export default "__VITE_ASSET__PEps1yP7__"